export default __webpack_public_path__ + "static/media/city-hall-website-negative.51a4b163.svg";